import React, {Component} from "react";
import Loader from "../../../Common/Component/Loader";
import {message, Table, Dropdown, Menu, Modal, Drawer, Select, DatePicker} from "antd";
import DataTable from "./DataTable";
import {EllipsisOutlined} from '@ant-design/icons';
import Resource from "./Resource";
import {orderBy} from "lodash";
import moment from "moment-timezone";

const {Option} = Select;
const { RangePicker } = DatePicker;

const satisfaction_score = [{key: '>=90', value: '90% or Greater 90%'},
  {key: '>=75', value: '75% or Greater'},
  {key: '<75', value: '75% or Less'},
  {key: '<50', value: '50% or Less'},
]

class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      listPagination: { showSizeChanger: false, pageSize: 15, ordering: "", current: 1 },
      activePagination: '15',
      list: {},
      filterData: {},
      showResource: false,
      uuid: '',
      search_value: props.search_value,
      selectedRow: {},
      showDelete: false,
    }
  }

  componentDidMount = () => {
    const {activePagination, search_value} = this.state;
    this.setState({loader: true});

    // get logged in user roles
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)

    this.setState({logged_in_user_role}, () => {
      const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole();
      this.props.getCommercialCustomerList({
        limit: activePagination,
        offset: 0,
        search: search_value,
        commercial_profile__field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
      }) // get list of commercial customers
    })
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {search_value, activePagination, listPagination, list, filterData} = this.state;
    // message.destroy();
    this.setState({loader: false});
    // get franchise list
    if (Object.keys(nextProps?.Settings?.franchise).length > 0 && nextProps?.Settings?.franchise !== this.props.Settings?.franchise) {
      this.setState({franchiseList: nextProps?.Settings?.franchise});
    }

    // get customer list
    if (Object.keys(nextProps?.CommercialCustomer?.list).length > 0 && JSON.stringify(nextProps?.CommercialCustomer?.list) !== JSON.stringify(list)) {
      this.setState({list: nextProps?.CommercialCustomer?.list});
    }

    // get filter conditions
    if (Object.keys(nextProps?.filterData).length > 0 && JSON.stringify(nextProps?.filterData) !== JSON.stringify(filterData)) {
      this.setState({filterData: nextProps?.filterData}, () => {
        if (!this.props.showCustomerDrawer) this.onFilter()
      });
    }

    // search value
    if (nextProps?.search_value !== search_value && (nextProps?.search_value?.length >= 3 || nextProps?.search_value?.length === 0)) {
      setTimeout(() => {
        const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole();
        this.setState({search_value: nextProps?.search_value, listPagination: {...listPagination, current: 1}}, () => {
          this.props.getCommercialCustomerList({
            offset: 0,
            limit: activePagination,
            ordering: '',
            search: nextProps.search_value,
            commercial_profile__field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
          });
        })
      }, 500)
    }
  }

  // get logged in user
  getLoggedInUserRole = () => {
    const {logged_in_user_role} = this.state;

    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_franchise = logged_in_user_role?.includes('accounting_franchiese')
    const is_ope_mgr_franchise = logged_in_user_role?.includes('operations_mgr')
    const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese')
    const franchise_uuid = authUser?.user?.associated_field_offices?.map(x => x.uuid);
    return {is_franchise_owner, franchise_uuid: franchise_uuid?.[0], is_disable_franchise_dropdown: (is_franchise_owner || is_ope_mgr_franchise || is_account_franchise || is_buss_dev_franchise)}
  }

  toggleResource = (value) => {
    if (value !== this.state.showResource) {
      this.setState({showResource: value})
    }
  }

  toggleDeleteModal = () => {
    this.setState((prevState) => ({showDelete: !prevState.showDelete}))
  }

  // on customer filter
  onFilter = () => {
    const {filterData, activePagination, search_value, listPagination} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole()
    this.setState({loader: true, listPagination: {...listPagination, current: 1}})
    const obj = {
      offset: 0,
      limit: activePagination,
      ordering: '',
      search: search_value,
      commercial_profile__field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
    };

    (filterData?.franchise && filterData?.franchise !== 'all') &&
    Object.assign(obj, {commercial_profile__field_office__uuid__in: filterData?.franchise});

    if (filterData?.joined?.length > 0) {
      Object.assign(obj, {created_at__lte: new Date(filterData?.joined?.[1]), created_at__gte: new Date(filterData?.joined?.[0])});
    }

    if (filterData?.lastService?.length > 0) {
      Object.assign(obj, {last_serviced: `${moment(filterData?.lastService?.[0]).format('YYYY-MM-DD')},${moment(filterData?.lastService?.[1]).format('YYYY-MM-DD')}`});
    }

    if(filterData?.satisfaction) {
      if(filterData?.satisfaction === '>=90' || filterData?.satisfaction === '>=75' ) {
        Object.assign(obj, {customer_satisfaction_score__gte: filterData?.satisfaction ? filterData?.satisfaction === '>=90' ? '90' : '75' : ''})
      }
      else {
        Object.assign(obj, {customer_satisfaction_score__lte: filterData?.satisfaction ? filterData?.satisfaction === '<75' ? '75' : '50' : ''})
      }
    }

    if ((filterData?.active && !filterData?.inactive) || (!filterData?.active && filterData?.inactive)) {
      Object.assign(obj, {is_active: filterData?.active === true ? true : filterData?.inactive === true && false});
    }

    this.props.getCommercialCustomerList(obj);
  }

  //Table Order and Pagination
  onTableChange = (pagination, filters, sorter) => {
    const {listPagination, activePagination, filterData, search_value} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole();
    let ordering = '';
    Object.assign(listPagination, { current: pagination.current });

    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = ''
    }

    this.setState({
      list: {},
      listPagination,
      loader: true
    });

    let obj = { 
      offset: ((pagination.current - 1) * activePagination),
      limit: pagination?.pageSize,
      ordering,
      search: search_value,
      commercial_profile__field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''
    };

    if (filters?.franchise || (filterData?.franchise && filterData?.franchise !== 'all')) {
      Object.assign(obj,{commercial_profile__field_office__uuid__in: filters?.franchise?.toString() || filterData?.franchise});
    }

    if (filterData?.joined?.length > 0) {
      Object.assign(obj, {created_at__lte: new Date(filterData?.joined?.[1]), created_at__gte: new Date(filterData?.joined?.[0])});
    }

    if (filterData?.lastService?.length > 0) {
      Object.assign(obj, {last_serviced: `${moment(filterData?.lastService?.[0]).format('YYYY-MM-DD')},${moment(filterData?.lastService?.[1]).format('YYYY-MM-DD')}`});
    }

    if(filterData?.satisfaction) {
      if(filterData?.satisfaction === '>=90' || filterData?.satisfaction === '>=75' ) {
        Object.assign(obj, {customer_satisfaction_score__gte: filterData?.satisfaction ? filterData?.satisfaction === '>=90' ? '90' : '75' : ''})
      }
      else {
        Object.assign(obj, {customer_satisfaction_score__lte: filterData?.satisfaction ? filterData?.satisfaction === '<75' ? '75' : '50' : ''})
      }
    }

    if ((filterData?.active && !filterData?.inactive) || (!filterData?.active && filterData?.inactive)) {
      Object.assign(obj, {is_active: filterData?.active === true ? true : filterData?.inactive === true && false});
    }

    this.props.getCommercialCustomerList(obj);

  }

  // page size change
  setPageLimit = (value) => {
    const {listPagination, filterData} = this.state;
    const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole();

    Object.assign(listPagination, { current: 1, pageSize: value, ordering: '' });

    this.setState({activePagination: value, listPagination});

    this.props.getCommercialCustomerList({
      offset: 0,
      limit: value,
      ordering: '',
      commercial_profile__field_office__uuid__in: is_franchise_owner ? franchise_uuid : filterData.franchise != 'all' ? filterData.franchise : ''
    });
  };

  // on customer list row
  onListRow = (record) => {
    return {
      onClick: () => {
        this.props.history.push(`/commercial/customer-detail`, { query: { 'id': record?.uuid, hear_about_us: record?.hear_about_us, customer_satisfaction_score: record?.customer_satisfaction_score } })
      }
    }
  }

  onDeleteCustomer = () => {
    this.setState({loader: true});
    this.props.deleteCommercialCustomer(this.state.uuid)
    setTimeout(() => {
      const {activePagination} = this.state;
      const {is_franchise_owner, franchise_uuid} = this.getLoggedInUserRole();
      this.setState({loader: true});
      this.props.getCommercialCustomerList({limit: activePagination, offset: 0, commercial_profile__field_office__uuid__in: is_franchise_owner ? franchise_uuid : ''}) // get list of commercial customers
      this.toggleDeleteModal()
    }, 1000)
  }

  onActionChange = (e, action, uuid, row) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({uuid: uuid, selectedRow: row}, () => {
      switch (action) {
      case 'edit':
        this.props.history.push(`/commercial/customer-detail`, { query: { 'id': row?.uuid, hear_about_us: row?.hear_about_us, customer_satisfaction_score: row?.customer_satisfaction_score, selectedTab: 1 } })
        break;
      case 'resource':
        this.toggleResource(true);
        break;
      case 'delete':
        this.setState({uuid}, () => this.toggleDeleteModal())
        break;
      default:
        console.log('no action')
      }
    })
  }
  
  // render table action
  renderAction = (uuid, row) => {
    const menu = (
      <Menu>
        {/* <Menu.Item key="0"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'edit', uuid, row)}>Edit</a></Menu.Item>*/}
        <Menu.Item key="1"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'resource', uuid, row)}>Resource</a></Menu.Item>
        {/* <Menu.Item key="2"><a href={'/#'} onClick={(e) => this.onActionChange(e, 'delete', uuid)}>Delete</a></Menu.Item>*/}
      </Menu>
    )

    return (
      <Dropdown overlay={menu} trigger={['hover']}>
        <span onClick={e => e.preventDefault()}>
          <EllipsisOutlined />
        </span>
      </Dropdown>
    )
  }

  ///////////////////////////////////////////////////////////

  // render customer filter drawer
  renderDrawer = () => {
    const {
      filterData,
      franchiseList,
    } = this.state;

    const {showCustomerDrawer: openDrawer} = this.props;

    const {is_disable_franchise_dropdown} = this.getLoggedInUserRole()
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={() => this.props.toggleCustomerDrawer(false)}
        visible={openDrawer}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="group_wrapper rdrawer">
          <div className="card-head">
            <h4>Filter Customer</h4>
          </div>
          <div className="card-row">
            <div className="card-full">
              {/* <CloseOutlined onClick={() => this.closeDrawer()}/>                   */}
              <div className="form-group">
                <div className="fitem">
                  <label>Customer Status</label>
                  <div className="fitem-check">
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`active`}
                      name={'active'}
                      checked={filterData?.active}
                      onChange={(e) => this.props.onFilterChange(e, 'bool')} />
                    <label htmlFor={`active`} className="fitem-ck-txt mb-0">{'Active'}</label>
                  </div>
                  <div className="fitem-check">
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`inactive`}
                      name={'inactive'}
                      checked={filterData?.inactive}
                      onChange={(e) => this.props.onFilterChange(e, 'bool')} />
                    <label htmlFor={`inactive`} className="fitem-ck-txt mb-0">{'Inactive'}</label>
                  </div>
                </div>
                <div className="fitem">
                  <label htmlFor="customerFranchise">Franchise</label>
                  <Select
                    disabled={is_disable_franchise_dropdown}
                    id={"customerFranchise"}
                    placeholder="Select a Franchise"
                    name="franchise"
                    onChange={(e) => this.props.onFilterChange({target: {name: 'franchise', value: e}})}
                    value={filterData?.franchise || undefined}>
                    <Option key={'franchiseAll'} value={'all'}>{'All'}</Option>
                    {
                      orderBy(franchiseList?.results, 'id', 'asc')?.map((option) =>
                        <Option key={option?.uuid} value={option?.uuid}>{option?.name}</Option>)
                    }
                  </Select>
                </div>
                <div className="fitem">
                  <label htmlFor="customerFranchise">Joined</label>
                  <RangePicker
                    style={{ 'width': '100%' }}
                    allowClear={true}
                    separator='-'
                    format={"MMM DD, YYYY"}
                    dropdownClassName='current_month'
                    value={filterData?.joined?.length > 0 ? [filterData?.joined?.[0] ? moment(filterData?.joined?.[0]) : undefined, filterData?.joined?.[1] ? moment(filterData?.joined?.[1]) : undefined] : undefined}
                    onChange={(e) => {
                      if (e === null) {
                        this.props.onFilterChange({ target: { name: 'joined', value: [] } });
                      } else {
                        this.props.onFilterChange({ target: { name: 'joined', value: [e?.[0]?.format('YYYY-MM-DD'), e?.[1]?.format('YYYY-MM-DD')] } })
                      }
                    }} />
                </div>
                <div className="fitem">
                  <label htmlFor="customerFranchise">Last Serviced</label>
                  <RangePicker
                    style={{ 'width': '100%' }}
                    allowClear={true}
                    separator='-'
                    format={"MMM DD, YYYY"}
                    dropdownClassName='current_month'
                    value={filterData?.lastService?.length > 0 ? [filterData?.lastService?.[0] ? moment(filterData?.lastService?.[0]) : undefined, filterData?.lastService?.[1] ? moment(filterData?.lastService?.[1]) : undefined] : undefined}
                    onChange={(e) => {
                      if (e === null) {
                        this.props.onFilterChange({ target: { name: 'lastService', value: [] } });
                      } else {
                        this.props.onFilterChange({ target: { name: 'lastService', value: [e?.[0]?.format('YYYY-MM-DD'), e?.[1]?.format('YYYY-MM-DD')] } })
                      }
                    }} />
                </div>
                {/*<div className="fitem">*/}
                {/*  <label htmlFor="customerFranchise">Balance Outstanding</label>*/}
                {/*  <Select*/}
                {/*    placeholder="Enter Range"*/}
                {/*    name="outstanding"*/}
                {/*    onChange={(e) => this.props.onFilterChange({target: {name: 'outstanding', value: e}})}*/}
                {/*    value={filterData?.outstanding || undefined}>*/}
                {/*    /!*{*!/*/}
                {/*    /!*  franchiseList?.results?.map((option) =>*!/*/}
                {/*    /!*    <Option key={option?.uuid} value={option?.uuid}>{option?.name}</Option>)*!/*/}
                {/*    /!*}*!/*/}
                {/*  </Select>*/}
                {/*</div>*/}
                <div className="fitem">
                  <label htmlFor="customerFranchise">Satisfaction Score</label>
                  <Select
                    placeholder="Enter Satisfaction Score"
                    name="satisfaction"
                    onChange={(e) => this.props.onFilterChange({target: {name: 'satisfaction', value: e}})}
                    value={filterData?.satisfaction || undefined}>
                    {
                      satisfaction_score?.map((option) =>
                        <Option key={option?.key} value={option?.key}>{option?.value}</Option>)
                    }
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn`} onClick={() => {this.props.toggleCustomerDrawer(); this.props.onClearCustomerFilter();}}>Cancel</button>
            <button
              // type="submit"
              className={`btn`}
              onClick={() => this.onFilter()}>
              Filter Customer
            </button>
          </div>
        </div>
      </Drawer>
    )
  };

  render() {
    const {list, listPagination, activePagination, loader, franchiseList, uuid, showResource, selectedRow, showDelete} = this.state;
    const franchise = franchiseList?.results?.map((item) => ({text: item?.name, value: item?.uuid}));

    return (
      <div>
        {loader && <Loader />}
        <Table
          rowKey={record => record?.uuid}
          dataSource={list?.results}
          pagination={{...listPagination, total: list?.count}}
          columns={DataTable.customerColumns(franchise, this)}
          onChange={this.onTableChange}
          onRow={this.onListRow}
          className="customer-list filt-shift-left"
        />
        {list?.results?.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setPageLimit('15') }}
                className={activePagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={activePagination === '30' ? 'active' : ''}
                onClick={() => { this.setPageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={activePagination === '60' ? 'active' : ''}
                onClick={() => { this.setPageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
        {this.renderDrawer()}
        {showResource && <Resource
          customerId={uuid}
          selectedRow={selectedRow}
          closeDrawer={() => this.toggleResource(false)}
          openDrawer={showResource}
          getResourceList={this.props.getResourceList}
          addResource={this.props.addResource}
          updateResource={this.props.updateResource}
          deleteResource={this.props.deleteResource}

          Resource={this.props.Resource}
        />}
        <Modal
          title="Delete Customer"
          visible={showDelete}
          onCancel={() => this.toggleDeleteModal()}
          className="delete_user_modal"
          width={400}
          footer={[
            <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => this.toggleDeleteModal()}>No</button>,
            <button key="upload" className={`btn btn-waning`} onClick={() => this.onDeleteCustomer()}>Yes</button>,
          ]}
        >
          <div>
            <h2> Are You Sure ?</h2>
          </div>
        </Modal>
      </div>
    )
  }
}

export default Customer